module.exports = __webpack_public_path__ + "img/claims-image-3b-wide.471f32de.png";